(() => {
  const initialize = (section) => {
    const range = section.querySelector('[data-before-after-range]');
    if (!range || range.dataset.beforeAfterReady === 'true') return;
    range.dataset.beforeAfterReady = 'true';
    const update = () => section.style.setProperty('--before-after-position', `${range.value}%`);
    range.addEventListener('input', update);
    update();
    section.dataset.beforeAfterReady = 'true';
  };
  document.querySelectorAll('[data-before-after]').forEach(initialize);
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-before-after]').forEach(initialize));
})();
